export const PolyMicronType = [
    {id: 0, name: 50},
    {id: 1, name: 55},
    {id: 2, name: 60},
]